/* eslint-disable no-return-assign */
/**
 * @version: v2.0.0-1
 * @author: Keval Bhatt
 * @copyright: Copyright (c) 2015 Keval Bhatt. All rights reserved.
 * @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
 * @website: http://kevalbhatt.github.io/timezone-picker/
 */

/**
 * [plugin register jquery plugin]
 * @param  {[string]}  options.name [Plugin name]
 * @param  {[object]}  options.classRef [Class object]
 * @param  {Boolean} options.shortHand  [Generate a shorthand as $.pluginName]
 * @return {[type]}                     [description]
 */

import $ from 'jquery';

export default function plugin({ pluginName, ClassRef, shortHand = false }) {
  const dataName = `${pluginName}`;
  const old = $.fn[pluginName];

  $.fn[pluginName] = (option) => {
    return this.each(() => {
      const $this = $(this);
      let data = $this.data(dataName);
      const options = $.extend({}, ClassRef.DEFAULTS, $this.data(), typeof option === 'object' && option);

      if (!data) {
        $this.data(dataName, (data = new ClassRef($this, options)));
      }

      if (typeof option === 'string') {
        data[option]();
      }
    });
  };

  // - Short hand
  if (shortHand) {
    $[pluginName] = (options) => {
      return (
        $({})[pluginName](options)
      );
    };
  }

  // - No conflict
  $.fn[pluginName].noConflict = () => {
    return (
      $.fn[pluginName] = old
    );
  };
}
